import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/logo.png";
import StripeCheckout from "react-stripe-checkout";
import { fromDollarToCent } from "../../../common/helper/helper";
import { STRIPE_PUBLISHABLE_KEY } from "../../../common/constant";

const Subscription = ({
  decodedData,
  handlePayment,
  paymentDoneStatus,
  isPaymentLoading,
}) => {
  const navigate = useNavigate();
  const isPaymentDone = !!paymentDoneStatus;
  return (
    <section className="subscription-auth-page">
      <div className="container-fluid">
        <div className="subscription-auth-wrapper">
          <div className="subscription-auth-card">
            <header className="subscription-auth-header">
              <div className="subscription-auth-logo">
                <Link to="/login">
                  <img src={Logo} alt="logo" />
                </Link>
              </div>
            </header>
            {!isPaymentDone && (
              <div className="subscription-auth-card-header">
                <h2>Subscription</h2>
                <p>Complete your subscription to continue</p>
              </div>
            )}
            {isPaymentDone ? (
              <>
                <div className="subscription-auth-success-wrapper">
                  <div className="subscription-auth-success-icon">
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 80 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="40" cy="40" r="40" fill="#10B981" />
                      <path
                        d="M25 40L35 50L55 30"
                        stroke="white"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="subscription-auth-success-content">
                    <h3 className="subscription-auth-success-title">
                      Payment Successful!
                    </h3>
                    <p className="subscription-auth-success-message">
                      Your subscription has been activated successfully for{" "}
                      {decodedData.centerName}. You can now access all features
                      in the mobile app.
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  className="subscription-auth-button"
                  onClick={() => navigate("/login")}
                >
                  Go to Login
                </button>
              </>
            ) : (
              <>
                <div className="subscription-auth-details">
                  <div className="subscription-auth-info-item">
                    <span className="subscription-auth-label">Email</span>
                    <span className="subscription-auth-value">
                      {decodedData.userEmail || "N/A"}
                    </span>
                  </div>
                  <div className="subscription-auth-divider"></div>
                  <div className="subscription-auth-info-item">
                    <span className="subscription-auth-label">Centre</span>
                    <span className="subscription-auth-value">
                      {decodedData.centerName || "N/A"}
                    </span>
                  </div>
                  <div className="subscription-auth-divider"></div>

                  <div className="subscription-auth-info-item">
                    <span className="subscription-auth-label">
                      Amount to Pay
                    </span>
                    <span className="subscription-auth-value subscription-auth-amount">
                      <span className="subscription-auth-currency">&#163;</span>
                      {decodedData.amount}
                    </span>
                  </div>
                </div>
                <StripeCheckout
                  label="Pay with stripe"
                  name="Test Routes"
                  email={decodedData.userEmail}
                  description="Powered by Stripe"
                  image="https://cdn.testroutes.co.uk/logo/logo.png"
                  amount={fromDollarToCent(decodedData.amount)}
                  token={handlePayment(
                    decodedData.productId,
                    decodedData.centerId,
                    decodedData.userId
                  )}
                  currency={decodedData.currency}
                  stripeKey={STRIPE_PUBLISHABLE_KEY}
                  zipCode
                  allowRememberMe
                >
                  <button
                    type="button"
                    className="subscription-auth-button"
                    disabled={isPaymentLoading}
                  >
                    {isPaymentLoading
                      ? "Processing..."
                      : `Pay £${decodedData.amount}`}
                  </button>
                </StripeCheckout>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscription;
